<template>
  <div class="content">
    <div class="left">
      <div style="display: flex; flex-direction: column; margin-bottom: 30px">
        <span style="font-size: 24px; color: #333333; margin-bottom: 20px">{{
          $t("profile.settingPage.title")
        }}</span>
        <div>
          <el-button type="primary" @click="openDialog">{{
            $t("profile.settingPage.addSecurity")
          }}</el-button>
        </div>
      </div>
      <div class="form">
        <el-table :data="tabletData" style="width: 100%">
          <el-table-column
            prop="question"
            :label="$t('profile.settingPage.question')"
          >
          </el-table-column>
          <el-table-column
            prop="answer"
            :label="$t('profile.settingPage.answer')"
          >
          </el-table-column>
          <el-table-column
            prop="line"
            :label="$t('profile.settingPage.operations')"
          >
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="editRow(scope?.row)">
                {{ $t("profile.settingPage.change") }}
              </el-button>
              <el-button
                @click="deleteRow(scope.row?.id)"
                type="text"
                size="small"
                >{{ $t("profile.settingPage.delete") }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
        :title="openType == 'add' ? '添加密保问题' : '修改密保问题'"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="400px"
        @close="cancel"
      >
        <!-- 表单内容 -->
        <el-form
          ref="verifyForm"
          :model="form"
          :rules="rules"
          label-width="100px"
          class="verify-form"
        >
          <!-- 密保问题 -->
          <el-form-item label="密保问题" prop="question">
            <!-- <el-input
              v-model="form.question"
              placeholder="请输入密保问题"
              maxlength="20"
            ></el-input> -->
            <el-select
              v-model="form.question"
              placeholder="请选择密保问题"
              :disabled="openType == 'edit'"
            >
              <el-option
                v-for="(item, index) in questionList"
                :key="index"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <!-- 密保答案 -->
          <el-form-item label="密保答案" prop="answer">
            <el-input
              v-model="form.answer"
              placeholder="请输入密保答案"
              maxlength="18"
            ></el-input>
          </el-form-item>
        </el-form>

        <!-- 弹窗底部按钮 -->
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel">取消</el-button>
          <el-button type="primary" @click="submitForm">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { getImageUrl } from "@/utils/imageHelper";
import request from "@/api/request";
export default {
  data() {
    return {
      avtor: require("@/assets/img/personal/avtor.png"),
      userInfo: {},
      tabletData: [],
      dialogVisible: false,
      form: {
        question: "",
        answer: "",
      },
      // 验证规则
      rules: {
        question: [
          { required: true, message: "请输入密保问题", trigger: "blur" },
          {
            trigger: "change",
          },
        ],
        answer: [
          { required: true, message: "请输入密保答案", trigger: "blur" },
          {
            trigger: "blur",
          },
        ],
      },
      questionList: [],
      openType: "",
      currentId: "",
    };
  },
  computed: {
    // 计算属性方式
    avatarUrl() {
      return getImageUrl(this.avtor);
    },
  },
  created() {
    this.userInfo = {
      ...JSON.parse(localStorage.getItem("accountInfo"))?.data,
    };
    this.avtor = this.userInfo.avatar;
    this.getTableData();
    this.getQuestionDic();
  },
  methods: {
    cancel() {
      this.form.answer = "";
      this.form.question = "";
      this.dialogVisible = false;
    },
    getQuestionDic() {
      request({
        url: `/api/sys/dict/all`,
        method: "get",
      })
        .then((res) => {
          res.forEach((item) => {
            if (item.type == "user_question") {
              this.questionList = [...item.dictDatas];
            }
          });
        })
        .catch((error) => {});
    },
    deleteRow(id) {
      request({
        url: `/api/user/qa/del?id=${id}`,
        method: "get",
      })
        .then((res) => {
          this.$message.success("删除成功");
          this.getTableData();
        })
        .catch((error) => {});
    },
    editRow(obj) {
      this.openType = "edit";
      this.dialogVisible = true;
      this.form.answer = obj.answer;
      this.form.question = obj.question;
      this.currentId = obj.id;
    },
    openDialog() {
      this.openType = "add";
      this.dialogVisible = true;
    },
    submitForm() {
      this.$refs.verifyForm.validate((valid) => {
        if (valid) {
          if (this.openType == "add") {
            // 表单验证通过，处理提交逻辑
            request({
              url: `/api/user/qa/add`,
              method: "post",
              data: {
                question: this.form?.question,
                answer: this.form?.answer,
              },
            })
              .then((res) => {
                this.$message.success("添加成功");
                this.getTableData();
              })
              .catch((error) => {});

            console.log("提交的信息:", this.form);

            // 关闭弹窗
            this.dialogVisible = false;

            // 重置表单
            this.$refs.verifyForm.resetFields();
          } else if (this.openType == "edit") {
            // 表单验证通过，处理提交逻辑
            request({
              url: `/api/user/qa/edit`,
              method: "post",
              data: {
                id: this.currentId,
                answer: this.form?.answer,
              },
            })
              .then((res) => {
                this.$message.success("修改成功");
                this.getTableData();
              })
              .catch((error) => {});

            console.log("提交的信息:", this.form);

            // 关闭弹窗
            this.dialogVisible = false;

            // 重置表单
            this.$refs.verifyForm.resetFields();
          }
        } else {
          this.$message.error("请完善表单信息");
          return false;
        }
      });
    },
    getTableData() {
      request({
        url: `/api/user/qa/list`,
        method: "get",
      })
        .then((res) => {
          this.tabletData = [...res?.data];
        })
        .catch((error) => {});
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  height: 600px;
  .left {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 20px;
    .form {
      ::v-deep .el-table__header th {
        background-color: #f5f7fb;
        font-weight: bold;
        color: #333333;
      }
    }
  }
  .right {
    background-image: url("@/assets/img/personal/editPassBg.png");
    background-size: contain;
    background-repeat: no-repeat;
    height: 100%;
    // width: 25%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .info {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 20%;
    }
    .answer {
      display: flex;
      flex-direction: column;
      padding: 15px;
      font-size: 14px;
      color: #666666;
      background: #f5f7fb;
      border-radius: 4px;
      width: 80%;
      margin-top: 15px;
    }
  }
}
</style>
